import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { useStateContext } from '~/contexts/ContextProvider';

const Statistics = ({ title }) => {
  const { formatMoney } = useStateContext();
  const { state } = useLocation;

  document.title = title;

  return (
    <Fragment>
      <div className="flex flex-col">
        <h3 className="font-semibold text-2xl">Thời gian trả hoa hồng :</h3>
        <span className="text-lg py-2">Hàng tháng</span>
      </div>
      <div className="flex flex-col">
        <h3 className="font-semibold text-2xl">Tổng khách đã thua :</h3>
        <span className="text-lg py-2">{formatMoney(0)}</span>
      </div>
      <div className="flex flex-col">
        <h3 className="font-semibold text-2xl">Tổng khuyến mại :</h3>
        <span className="text-lg py-2">{formatMoney(0)}</span>
      </div>
      <div className="flex flex-col">
        <h3 className="font-semibold text-2xl">Tổng thường VIP :</h3>
        <span className="text-lg py-2">{formatMoney(0)}</span>
      </div>
      <div className="flex flex-col">
        <h3 className="font-semibold text-2xl">Tổng Giftcode :</h3>
        <span className="text-lg py-2">{formatMoney(0)}</span>
      </div>
      <div className="flex flex-col">
        <h3 className="font-semibold text-2xl">Hoa hồng hiện tại :</h3>
        <span className="text-lg py-2">10%</span>
      </div>
      <div className="flex flex-col">
        <h3 className="font-semibold text-2xl">Thành hoa hồng :</h3>
        <span className="text-lg py-2">{formatMoney(0)}</span>
      </div>
    </Fragment>
  );
};

export default Statistics;
